import React, { useCallback, useState, ReactElement } from 'react';
import Card from '../card/card.component';
import Hint from '../hint/hint.component';
import Button from '../button/button.component';
import ErrorBlock from '../error-block/error-block.component';
import ModalLabel from '../modal-label/modal-label.component';
import ModalLayout from '../modal-layout/modal-layout.component';
import ModalFieldBlock from '../modal-field-block/modal-field-block.component';
import ModalButtonBlock from '../modal-button-block/modal-button-block.component';
import FieldText from '../field-text/field-text.component';
import FormatService from '../../services/format-service';

const OktaAccountModal: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    isOpen,
    errorMessage,
    onCloseModal,
    onApplyOktaAccountNameClick,
  } = props;

  const [oktaAccountName, setOktaAccountName]: [string, Function] = useState('');
  const [modalErrorMessage, setModalErrorMessage]: [string | null, Function] = useState(null);

  const oktaAccountNameChange: Function = useCallback((oktaAccountNameValue: string): void => {
    setOktaAccountName(oktaAccountNameValue);
  }, []);

  const applyOktaAccountNameClick: MouseEventHandlerFunction = useCallback((): void => {
    if (oktaAccountName && FormatService.isValidSubdomain(oktaAccountName)) {
      setModalErrorMessage(null);

      if (onApplyOktaAccountNameClick) {
        onApplyOktaAccountNameClick(oktaAccountName);
      }
    } else if (!oktaAccountName) {
      setModalErrorMessage('Account Name is required');
    } else {
      setModalErrorMessage(null);
    }
  }, [oktaAccountName]);

  return (
    <ModalLayout isOpen={isOpen} title="Sign In with Okta" onCloseModal={onCloseModal}>
      <Card isContainer>
        <ModalLabel>
          Enter Okta Account Name (subdomain) to sign in:
          <Hint title="Okta subdomain name (like https://YourAccountName.okta.com/)" />
        </ModalLabel>
        <ModalFieldBlock>
          <FieldText
            isPlain
            isBordered
            maxLength={FormatService.STRING_LIMIT_DEFAULT}
            value={oktaAccountName}
            onChange={(event: React.ChangeEvent, value: string): void => {
              oktaAccountNameChange(value);
            }}
          />
        </ModalFieldBlock>
      </Card>
      <ModalButtonBlock>
        <Button onClick={onCloseModal}>
          Cancel
        </Button>
        <Button isActive onClick={applyOktaAccountNameClick}>
          Sign In
        </Button>
      </ModalButtonBlock>
      {
        (modalErrorMessage || errorMessage) && (
          <ErrorBlock errorMessage={modalErrorMessage || errorMessage} />
        )
      }
    </ModalLayout>
  );
});

export default OktaAccountModal;
